import React from 'react';
import { Mutation } from '../../reactApolloCompat';
import gql from 'graphql-tag';
import IconButton from '@mui/material/IconButton';
import withStyles from '@mui/styles/withStyles';
import Grid from '../layout/Grid';
import Inline, { inlineAlignment } from '../layout/Inline';
import FlexGrid from '../layout/FlexGrid';
import ViewContactModal from '../../views/Contacts/Modals/ViewContactModal';
import ContactAddNote from './ContactAddNote';
import Modal from '../modal/Modal';
import GatedComponent from '../GatedComponent';
import { capitalize, joinDefined, prettyEmail, prettyPhone, stringIsNullOrEmpty } from '../../utils/strings';
import {
    DeleteIcon,
    DriverDeliveryIcon,
    DriverPickupIcon,
    EnvelopeSquareIcon,
    FaxIcon,
    FireIcon,
    MapMarkerIcon,
    MobileIcon,
    PhoneSquareIcon
} from '../IconIndex';

class ContactCard extends React.Component {
    state = {
        item: null,
        showPickup: false,
        showDelivery: false
    };

    static getDerivedStateFromProps({ contact }, { item }) {
        if (contact && (!item || contact.ID !== item.ID)) {
            return { item: { ...contact } };
        }

        return null;
    }

    render() {
        const { variant, contact, classes, readOnly = false } = this.props;
        if (!contact) return null;
        let cssVariant = null;
        if (!stringIsNullOrEmpty(variant)) cssVariant = `contactcard--${variant}`;

        const { item, showPickup, showDelivery } = this.state;
        const address =
            item &&
            joinDefined(
                [
                    item.AddressLine1,
                    item.AddressLine2,
                    joinDefined(
                        [item.Suburb, item.State, item.Postcode, item.Country !== 'Australia' && item.Country],
                        ' '
                    )
                ],
                ', '
            );

        const { mutation, variables } = this.getRetirementMutation();

        return (
            <div className={`contactcard ${cssVariant || ''}`}
                 style={{ backgroundColor: item.NotCurrent ? '#FFFFFF99' : null }}>
                <Grid container spacing={2}>
                    <Grid item>
                        <GatedComponent>
                            {() => {
                                return (
                                    <Mutation
                                        mutation={mutation}
                                        onCompleted={this.onSaveCompleted}
                                        onError={e => this.handleMutateError(e)}
                                    >
                                        {(mutate, { loading }) => {
                                            const disabled = loading || readOnly;
                                            return (
                                                <IconButton
                                                    style={{
                                                        transform: item.NotCurrent ? 'rotate(180deg)' : null,
                                                        position: 'absolute',
                                                        top: 3,
                                                        right: 3,
                                                        zoom: 0.75
                                                    }}
                                                    aria-label="Delete"
                                                    className="icon"
                                                    title={item.NotCurrent ? 'Restore' : 'Retire'}
                                                    disabled={disabled}
                                                    onClick={e =>
                                                        this.onDeleteClicked(mutate, !disabled && variables, e)
                                                    } size="large">
                                                    <DeleteIcon />
                                                </IconButton>
                                            );
                                        }}
                                    </Mutation>
                                );
                            }}
                        </GatedComponent>
                        <h3 className="business-title">{item.Name}</h3>
                        {(!!item.Contact || !!item.AddressBookCategory) && <Inline center>
                            <p className="contact-name">{item.Contact}</p>
                            {!!item.AddressBookCategory &&
                                <p className="business-category">{item.AddressBookCategory}</p>}
                        </Inline>}
                    </Grid>

                    {address && (
                        <Grid item>
                            <Inline center nowrap>
                                <MapMarkerIcon className="contact-icon" />
                                <p className="location">{address}</p>
                            </Inline>
                        </Grid>
                    )}
                    {item.Phone && (
                        <FlexGrid variant="justify">
                            <Inline center nowrap className="contact-info">
                                <PhoneSquareIcon className="contact-icon" />
                                <p className="contact-details">{prettyPhone(item.Phone)}</p>
                            </Inline>
                        </FlexGrid>
                    )}
                    {item.Mobile && (
                        <FlexGrid variant="justify">
                            <Inline center nowrap className="contact-info">
                                <MobileIcon className="contact-icon" />
                                <p className="contact-details">{prettyPhone(item.Mobile)}</p>
                            </Inline>
                        </FlexGrid>
                    )}
                    {item.Fax && (
                        <FlexGrid variant="justify">
                            <Inline center nowrap className="contact-info">
                                <FaxIcon className="contact-icon" />
                                <p className="contact-details">{prettyPhone(item.Fax)}</p>
                            </Inline>
                        </FlexGrid>
                    )}
                    {item.Email && (
                        <FlexGrid variant="justify">
                            <Inline center nowrap className="contact-info">
                                <EnvelopeSquareIcon className="contact-icon" />
                                <p className="contact-details">{prettyEmail(item.Email)}</p>
                            </Inline>
                        </FlexGrid>
                    )}
                    {item.NotifyBeforeInsertion && (
                        <FlexGrid variant="justify">
                            <Inline center nowrap className="contact-info">
                                <FireIcon className="contact-icon" />
                                <p className="contact-details">Notify before Insertion</p>
                            </Inline>
                        </FlexGrid>
                    )}
                </Grid>
                <Grid container spacing={2}>
                    <Grid item>
                        <Inline alignment={inlineAlignment.rightAlignSiblings} center>
                            <div />
                            {(!!item.CollectionNote || (item.PickupAddress && item.PickupAddress.ID > 0)) &&
                                <IconButton
                                    title="Pickup Notes"
                                    className={classes.buttonNote}
                                    onClick={() => this.setState({ showPickup: !showPickup })} size="large">
                                    <DriverPickupIcon />
                                </IconButton>
                            }
                            {!!item.DeliveryAddresses && !!item.DeliveryAddresses.length &&
                                <IconButton
                                    title="Delivery Notes"
                                    className={classes.buttonNote}
                                    onClick={() => this.setState({ showDelivery: !showDelivery })} size="large">
                                    <DriverDeliveryIcon />
                                </IconButton>
                            }
                            <ContactAddNote
                                onClose={this.updateContact}
                                contactId={item.ID}
                                contactNotes={item.Notes}
                                contact={item}
                            />
                            <ViewContactModal onClose={this.updateContact} contact={item} readOnly={readOnly} />
                        </Inline>
                    </Grid>
                </Grid>
                {!!item.DeliveryAddresses && !!item.DeliveryAddresses.length && <Modal
                    variant="simple"
                    open={showDelivery}
                    onClose={() => this.setState({ showDelivery: !showDelivery })}
                >
                    <Grid container className={classes.modalContent}>
                        <Grid item xs={12} sm={6}>
                            <div style={{ display: 'flex', gap: 16 }}>
                                <DriverDeliveryIcon style={{ width: 96, height: 96 }} />
                                <div>
                                    <h2>Delivery Notes</h2>
                                    <p>{item.Name}<br />{capitalize(item.Suburb || '')} {item.State}</p>
                                </div>
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            {item.DeliveryAddresses.map((obj, idx) => (
                                <p key={obj.ID}>
                                    <strong>Delivery Address #{1 + idx}:</strong><br />
                                    {joinDefined([
                                        obj.AddressLine1,
                                        obj.AddressLine2,
                                        obj.Suburb,
                                        obj.State
                                    ], ' ')}
                                </p>
                            ))}
                        </Grid>
                    </Grid>
                </Modal>}
                {(!!item.CollectionNote || (item.PickupAddress && item.PickupAddress.ID > 0)) && <Modal
                    variant="simple"
                    open={showPickup}
                    onClose={() => this.setState({ showPickup: !showPickup })}
                >
                    <Grid container className={classes.modalContent}>
                        <Grid item xs={12} sm={6}>
                            <div style={{ display: 'flex', gap: 16 }}>
                                <DriverPickupIcon style={{ width: 96, height: 96 }} />
                                <div>
                                    <h2>Pickup Notes</h2>
                                    <p>{item.Name}<br />{capitalize(item.Suburb || '')} {item.State}</p>
                                </div>
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            {!!item.CollectionNote && (
                                <p>
                                    <strong>Body Collection Note:</strong><br />
                                    {item.CollectionNote}
                                </p>
                            )}
                            {!!item.PickupAddress && item.PickupAddress.ID > 0 && (
                                <p>
                                    <strong>Pickup Address:</strong><br />
                                    {joinDefined([
                                        item.PickupAddress.AddressLine1,
                                        item.PickupAddress.AddressLine2,
                                        item.PickupAddress.Suburb,
                                        item.PickupAddress.State
                                    ], ' ')}
                                </p>
                            )}
                        </Grid>
                    </Grid>
                </Modal>}
            </div>
        );
    }

    onDeleteClicked = (mutate, variables, e) => {
        e.preventDefault();
        let msg = 'You\'re about to retire this contact.\nAre you sure?';
        if (!variables.input.NotCurrent) msg = 'You\'re about to restore this contact.\nAre you sure?';
        const axe = window.confirm(msg);
        if (axe) {
            if (variables) mutate({ variables }).then(({ data }) => {
                const { item } = this.state;
                this.setState({ item: { ...item, NotCurrent: data.updateCremationManagerAddressBook.NotCurrent } });
            });
        }
    };

    updateContact = (newData) => {
        const { item } = this.state;
        const { onUpdate } = this.props;
        this.setState({ item: { ...item, ...newData } }, () => onUpdate && onUpdate());
    };

    getRetirementMutation() {
        const { item } = this.state;
        return {
            mutation: gql`
                mutation RetireContact($input: UpdateCremationManagerAddressBookInput!) {
                    updateCremationManagerAddressBook(input: $input) {
                        ID
                        NotCurrent
                    }
                }
            `,
            variables: {
                input: { NotCurrent: !item.NotCurrent, ID: item.ID }
            }
        };
    }
}

const styles = ({ palette }) => ({
    buttonNote: {
        color: palette.primary.main
    },
    modalContent: {
        '& p': {
            margin: '1rem 0'
        }
    }
});
export default withStyles(styles)(ContactCard);
